import storable from 'helpers/storable'

export default storable('showImage', false)
